/**
 * Chain Of The Month – Featured Showcase
 * chain-of-the-month.js
 * Shopify 2.0 Asset — no external libraries
 */

(function () {
  'use strict';

  /* ── Intersection Observer: Fade Animations ── */
 function initAnimations(sectionEl) {
  if (!sectionEl) return;

  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Disable animations on mobile or if reduced motion is enabled
  if (isMobile || prefersReduced) {
    sectionEl.querySelectorAll('[data-cotm-animate], .cotm-trust-item').forEach(function (el) {
      el.classList.add('cotm-animated');
    });
    return;
  }

  // Fade-up / fade-left targets
  var fadeTargets = sectionEl.querySelectorAll('[data-cotm-animate]');

  var fadeObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = parseInt(entry.target.dataset.cotmDelay || '0', 10);
        setTimeout(function () {
          entry.target.classList.add('cotm-animated');
        }, delay);
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  fadeTargets.forEach(function (el, i) {
    el.dataset.cotmDelay = i * 120;
    fadeObserver.observe(el);
  });

  var trustItems = sectionEl.querySelectorAll('.cotm-trust-item');

  var trustObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = parseInt(entry.target.dataset.cotmDelay || '0', 10);
        setTimeout(function () {
          entry.target.classList.add('cotm-animated');
        }, delay);
        trustObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  trustItems.forEach(function (item, i) {
    item.dataset.cotmDelay = i * 100;
    trustObserver.observe(item);
  });
}

  /* ── Gold Glow Parallax on Mouse Move (desktop only) ── */
  function initGlowParallax(sectionEl) {
    if (!sectionEl) return;

    var glowEl = sectionEl.querySelector('.cotm-image__glow');
    if (!glowEl) return;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (isMobile) return;

    sectionEl.addEventListener('mousemove', function (e) {
      var rect = sectionEl.getBoundingClientRect();
      var xPct = (e.clientX - rect.left) / rect.width;
      var yPct = (e.clientY - rect.top)  / rect.height;

      var xOffset = (xPct - 0.5) * 30;
      var yOffset = (yPct - 0.5) * 20;

      glowEl.style.transform = 'translateX(calc(-50% + ' + xOffset + 'px)) translateY(' + yOffset + 'px)';
    });

    sectionEl.addEventListener('mouseleave', function () {
      glowEl.style.transform = 'translateX(-50%)';
    });
  }

  /* ── Button ripple micro-interaction ── */
  function initButtonRipple(sectionEl) {
    if (!sectionEl) return;

    sectionEl.querySelectorAll('.cotm-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var ripple = document.createElement('span');
        var rect = btn.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height) * 1.6;
        var x = e.clientX - rect.left - size / 2;
        var y = e.clientY - rect.top  - size / 2;

        ripple.style.cssText = [
          'position:absolute',
          'border-radius:50%',
          'pointer-events:none',
          'width:'  + size + 'px',
          'height:' + size + 'px',
          'left:'   + x   + 'px',
          'top:'    + y   + 'px',
          'background:rgba(255,255,255,0.25)',
          'transform:scale(0)',
          'animation:cotm-ripple 0.55s ease-out forwards',
        ].join(';');

        btn.style.position = 'relative';
        btn.style.overflow = 'hidden';
        btn.appendChild(ripple);

        setTimeout(function () {
          if (ripple.parentNode) ripple.parentNode.removeChild(ripple);
        }, 600);
      });
    });

    // Inject ripple keyframes once
    if (!document.getElementById('cotm-ripple-style')) {
      var style = document.createElement('style');
      style.id = 'cotm-ripple-style';
      style.textContent = '@keyframes cotm-ripple{to{transform:scale(1);opacity:0}}';
      document.head.appendChild(style);
    }
  }

  /* ── Init ── */
  function init() {
    document.querySelectorAll('[data-section-type="chain-of-the-month"]').forEach(function (section) {
      initAnimations(section);
      initGlowParallax(section);
      initButtonRipple(section);
    });
  }

  /* ── Shopify Theme Editor Live Reload ── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-section-type="chain-of-the-month"]');
      if (section) {
        initAnimations(section);
        initGlowParallax(section);
        initButtonRipple(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth > 768) return;

  const slider = document.querySelector('.cotm-trust-strip');
  const dotsWrap = document.querySelector('.cotm-trust-dots');

  if (!slider || !dotsWrap) return;

  const slides = slider.querySelectorAll('.cotm-trust-item');

  dotsWrap.innerHTML = '';

  slides.forEach((slide, index) => {

    const dot = document.createElement('button');
    dot.className = 'cotm-trust-dot';

    if (index === 0) {
      dot.classList.add('active');
    }

    dot.addEventListener('click', function () {
      slider.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth'
      });
    });

    dotsWrap.appendChild(dot);
  });

  const dots = dotsWrap.querySelectorAll('.cotm-trust-dot');

  slider.addEventListener('scroll', function () {

    const active = Math.round(slider.scrollLeft / slider.clientWidth);

    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === active);
    });

  }, { passive: true });

});